export const isWebpSupport =
  document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;

export const waitForImage = (src: string) =>
  new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.src = src;
  });
